import Heading from '../../Typography/Heading/Heading.mjs';
import styled from 'styled-components';

const StyledHeading = styled(Heading) `
  margin-top: 0;
  text-align: center;
`;

export { StyledHeading };
//# sourceMappingURL=PartnersSection.styles.mjs.map
